import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { TextField } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import { validarDocumento } from 'actions'
import { ButtonWithLoading } from 'components/ButtonWithLoading'
import { useFormState } from 'hooks/useFormState'

const schema = {
  codigoValidacao: {
    presence: { allowEmpty: false, message: '^Código de validação é obrigatório' },
  },
  dataAssinatura: {
    presence: { allowEmpty: false, message: '^Data de assinatura é obrigatório' },
  },
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fields: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
}))

export const Form = () => {
  const classes = useStyles()
  const router = useRouter()
  const validarDocumentoForm = useFormState(schema)

  return (
    <>
      <div className={classes.fields}>
        <TextField
          id="codigoValidacao"
          error={validarDocumentoForm.hasError('codigoValidacao')}
          fullWidth
          helperText={
            validarDocumentoForm.hasError('codigoValidacao')
              ? validarDocumentoForm.formState.errors.codigoValidacao[0]
              : null
          }
          label="Código de validação"
          name="codigoValidacao"
          onChange={validarDocumentoForm.handleChange}
          value={validarDocumentoForm.formState.values.codigoValidacao || ''}
          variant="outlined"
        />
        <TextField
          error={validarDocumentoForm.hasError('dataAssinatura')}
          fullWidth
          helperText={
            validarDocumentoForm.hasError('dataAssinatura')
              ? validarDocumentoForm.formState.errors.dataAssinatura[0]
              : null
          }
          label="Data do download"
          name="dataAssinatura"
          onChange={validarDocumentoForm.handleChange}
          type="date"
          value={validarDocumentoForm.formState.values.dataAssinatura || new Date()}
          variant="outlined"
          focused
        />
      </div>
      <ButtonWithLoading
        className={classes.submitButton}
        color="secondary"
        isDisabled={!validarDocumentoForm.formState.isValid}
        size="large"
        type="submit"
        variant="contained"
        label="Validar"
        isLoading={false}
        onClick={() =>
          validarDocumentoForm.handleSubmit(
            validarDocumento(validarDocumentoForm.formState.values, router)
          )
        }
      />
    </>
  )
}
